angular.module('zc.core')

.directive 'zcTermsOfServiceAppierInc', () ->
  restrict: 'E'
  templateUrl: '/templates/core/views/terms_of_service_appier_inc.html'



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/views/terms_of_service_appier_inc.directive.coffee